import React, { useEffect, useState } from 'react';
import { DailySalesResponse } from '../../../Interfaces/TeamAdminCoordDashboard';

interface SevenDaySalesProps {
    days_of_week: [
        DailySalesResponse,
        DailySalesResponse,
        DailySalesResponse,
        DailySalesResponse,
        DailySalesResponse,
        DailySalesResponse,
        DailySalesResponse
    ]; // should be most recent day last
    width: number;
    height: number;
  }

const Last7DaySales: React.FC<SevenDaySalesProps> = ({
    days_of_week, width, height
  }) => {
    const [barHeight, setBarHeight] = useState(100);
    const [barWidth, setBarWidth] = useState(10);
    const [barSpacing, setBarSpacing] = useState(20);
    const [fontSize, setFontSize] = useState(12); // Default font size
    const salesData = days_of_week.map((dayData) => dayData.sales);
    const days = days_of_week.map((dayData) => dayData.day.slice(0, 3)); 
    const maxValue = Math.max(...salesData) || 1;
    const maxIndex = salesData.lastIndexOf(maxValue);

    const updateWidth = () => {
        if (width > 0 && height > 0) {
          // Dynamically set radius based on container's width
          const newWidth = width / 2; // Adjust this ratio as needed
          const newBarHeight = height * 3/4;
          setBarHeight(newBarHeight);
          const barSpace = width/7;
          const newBarWidth = barSpace * .2;
          const newBarSpacing = (barSpace - newBarWidth)/2;
          setBarWidth(newBarWidth);
          setBarSpacing(newBarSpacing);
          const newFontSize = Math.max(newWidth / 8, 6); // Set a minimum font size of 12
          setFontSize(newFontSize);
        }
    };
    

    useEffect(() => {
        // Update the circle radius dynamically based on container width
        // + initial update on component mount
        updateWidth();
      }, [days_of_week, width, height]);

    return (
    <div  style={{ width: '100%', margin: '0 auto' }}>
        <header style={{ fontWeight: '700', paddingBottom: '5%', paddingTop:'5%', fontSize: fontSize*1.25}}>
            LAST 7 DAYS SALES
        </header>
        <svg width={width} height={height}>
            {salesData.map((value, index) => (
            <g key={index}>
                {/* Highlighted background for the max sales bar */}
                {index === maxIndex && (
                    <rect
                    x={index * barSpacing *2 + index * barWidth } // Position it a little wider around the bar
                    y={height * .07 - barHeight*.08} // Start from the bottom of the SVG
                    width= {barSpacing*2+barWidth} // Larger width than the regular bars
                    height={barHeight*1.16} // Same fixed height as the regular bars
                    fill="#d7dadf"  // gray color with reduced opacity (for highlighting)
                    rx={barWidth*2.3}  // Rounded corners for the highlight background
                    ry={barWidth*2.3}  // Rounded corners for the highlight background
                    />
                )}

                <rect
                    // key={index}
                    x={index * barSpacing *2+ index * barWidth  + barSpacing}
                    y={height * .07}
                    width={barWidth}
                    height={barHeight}
                    fill="#a2a2ac"  // for the outline gray: "#d7dadf"
                    rx="3"   // Horizontal rounding of corners
                    ry="3"   // Vertical rounding of corners
                />
                <rect
                    key={index}
                    x={index * barSpacing  *2+ index * barWidth  + barSpacing}
                    y={height * .07 + (barHeight) - (value / maxValue) * (barHeight*3/4)}
                    width={barWidth}
                    height={(value / maxValue) * (barHeight * 3/4)}
                    fill="#a2fa9a"
                    rx="3"   // Horizontal rounding of corners
                    ry="3"   // Vertical rounding of corners
                />
                {index !== maxIndex && (
                <text
                    x={index * barSpacing  *2+ index * barWidth  + barSpacing*1.3} // Center the text under the bar
                    y={height*.15 + barHeight} // Position the label slightly below the bar
                    fontSize={fontSize*.9}
                    textAnchor="middle" // Center the text horizontally
                    fill="#333" // Text color
                >
                    {days[index]} {/* Display the corresponding day of the week */}
                </text>)}
                {index === maxIndex && ( // want the text for the bar which is max to be slightly bolder and lower
                <text
                    x={index * barSpacing  *2+ index * barWidth  + barSpacing*1.3} // Center the text under the bar
                    y={height*.19 + barHeight} // Position the label slightly below the bar
                    fontSize={fontSize*.9}
                    textAnchor="middle" // Center the text horizontally
                    fill="#333" // Text color
                    fontWeight={700}
                >
                    {days[index]} {/* Display the corresponding day of the week */}
                </text>)}
            </g>
            ))}
        </svg>
    </div>    
        
    );

    
  };
  
export default Last7DaySales;